import gql from 'graphql-tag';

import accountSubscriptionFragment from '../fragments/accountSubscriptionFragment';

export const queryAccountSubscription = gql`
  query accountSubscription {
    accountSubscription {
      ...accountSubscriptionFragment
    }
  }
  ${accountSubscriptionFragment}
`;
export default queryAccountSubscription;
